// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"e986c6d8","531":"edee1ae6","550":"91e4ba51","967":"f6d8d108"}[chunkId] + ".chunk.js";
};